import { Flex } from 'foundations-components/components/Flex';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
export const BaseIconContainer = styled.div.withConfig({
  displayName: "BaseIcon__BaseIconContainer",
  componentId: "asan6e-0"
})(["svg{inline-size:60% !important;block-size:60% !important;}"]);
export const BaseIcon = ({
  children
}) => {
  return /*#__PURE__*/_jsx(BaseIconContainer, {
    children: /*#__PURE__*/_jsx(Flex, {
      position: "absolute",
      inset: "0",
      alignItems: "center",
      justifyContent: "center",
      children: children
    })
  });
};